import { useEffect, useState } from 'react';

export default function useStagingAutoRefresh(intervalMs = 30000) {
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    const refresh = () => {
      if (document.visibilityState === 'visible') {
        setRefreshKey(value => value + 1);
      }
    };

    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible') refresh();
    };

    const timer = window.setInterval(refresh, intervalMs);
    document.addEventListener('visibilitychange', onVisibilityChange);

    return () => {
      window.clearInterval(timer);
      document.removeEventListener('visibilitychange', onVisibilityChange);
    };
  }, [intervalMs]);

  return refreshKey;
}
